import script from "./ArchivedTaskDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchivedTaskDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./ArchivedTaskDetailModal.vue?vue&type=style&index=0&id=4d43417e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d43417e"]])

export default __exports__